import useFeaturedCars from 'hooks/useFeaturedCars';

import CarSliderSection from '../CarSliderSection/CarSliderSection';

const MostPopularCarsSection = () => {
  const { data: featuredCars, isValidating } = useFeaturedCars();

  return (
    <CarSliderSection
      vehicles={featuredCars}
      isValidating={isValidating}
      title="Most popular cars right now"
    />
  );
};

export default MostPopularCarsSection;
